module.exports = __webpack_public_path__ + "img/user-doctor-message.76aee63c.svg";